import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

// CSS読み込み 全体に適用
import './assets/bulma.sass';

// type
import { ContactInputType, CONTACT_INPUT_INIT } from './types/common/ContactType';
import { CustomerInformationInputType, CI_INPUT_TYPE_INIT } from './types/common/CustomerInformationType';

// 各部品呼び出し
import { PageHeader } from './components/PageHeader';
import { PageFooter } from './components/PageFooter';
import { TutorialModal } from './pages/Modals/TutorialModal';
import { Search } from './pages/Search/Search';
import { SearchResult } from './pages/SearchResult/SearchResult';
import { EditDeviceList } from './pages/EditDeviceList/EditDeviceList';
import { EditEstimate } from './pages/EditEstimate/EditEstimate';
import { CustomerInformation } from './pages/CustomerInformation/CustomerInformation';
import { Contact } from './pages/Contact/Contact';
import { Confirmation } from './pages/Confirmation/Confirmation';
import { Complete } from './pages/Complete/Complete';
import { NotFound } from './pages/NotFound/NotFound';
import { RecaptchaProvider } from './components/RecaptchaProvider';
import { store } from './store/store';

export const EstqRouter = () => {
    // チュートリアル モーダル開閉管理
    const [openTutorialModal, setOpenTutorialModal] = useState<boolean>(false);
    // 問い合わせ入力内容管理
    const [contactInput, setContactInput] = useState<ContactInputType>(CONTACT_INPUT_INIT);
    // 個人情報入力管理
    const [cIInput, setCIInput] = useState<CustomerInformationInputType>(CI_INPUT_TYPE_INIT);
    // 受付番号
    const [receiptNumber, setReceiptNumber] = useState<string>('');
    // tabの管理
    const [tabIndex, setTabIndex] = useState<number>(0);

    return (
        <BrowserRouter basename='/estq'>
            <Provider store={store}>
                <TutorialModal openState={openTutorialModal} setOpenState={setOpenTutorialModal} />
                <PageHeader setOpenTutorialModal={setOpenTutorialModal} tabIndex={tabIndex} setTabIndex={setTabIndex} />
                <Routes>
                    <Route path={'/'} element={<Search setOpenTutorialModal={setOpenTutorialModal} />} />
                    <Route path={'/searchResult'} element={<SearchResult />} />
                    <Route path={'/tempRestore/device'}>
                        <Route path=':draftInquiryEstimateId' element={<EditDeviceList />} />
                    </Route>
                    <Route path={'/tempRestore/estimate'}>
                        <Route path=':draftInquiryEstimateId' element={<EditEstimate />} />
                    </Route>
                    <Route path={'/editEstimate'} element={<EditEstimate />}></Route>
                    <Route path={'/editDeviceList'} element={<EditDeviceList />}></Route>
                    <Route
                        path={'/contact'}
                        element={<Contact contactInput={contactInput} setContactInput={setContactInput} />}
                    >
                        <Route
                            path=':moveButton'
                            element={<Contact contactInput={contactInput} setContactInput={setContactInput} />}
                        />
                    </Route>
                    <Route
                        path={'/customerInformation'}
                        element={<CustomerInformation cIInput={cIInput} setCIInput={setCIInput} />}
                    />
                    <Route
                        path={'/confirmation'}
                        element={
                            <RecaptchaProvider>
                                <Confirmation
                                    contactInput={contactInput}
                                    setContactInput={setContactInput}
                                    cIInput={cIInput}
                                    setCIInput={setCIInput}
                                    setReceiptNumber={setReceiptNumber}
                                />
                            </RecaptchaProvider>
                        }
                    />
                    <Route path={'/complete'} element={<Complete receiptNumber={receiptNumber} />} />
                    <Route path={'/*'} element={<NotFound />} />
                </Routes>
            </Provider>
            <PageFooter />
        </BrowserRouter>
    );
};
